import Twitter from '../../assets/icons/twitter.png';
import Spotify from '../../assets/icons/spotify.png';
import Google from '../../assets/icons/google.png';

type Social = 'twitter' | 'spotify' | 'google';

type Props = {
  social: Social;
};

const icon: { [key in Social]: string } = {
  twitter: Twitter,
  spotify: Spotify,
  google: Google,
};

export default function SocialButton({ social }: Props) {
  return (
    <div className="cursor-pointer" onClick={() => {}}>
      <img
        className="social-button"
        src={icon[social]}
        alt={`icon for ${social} button`}
      />
    </div>
  );
}
